const FREE_TRIAL_AUDIO_PATH = process.env.PUBLIC_URL + '/audios/free-trial';

export const getFreeTrialAudio = (number: number) =>
  `${FREE_TRIAL_AUDIO_PATH}/audio${number}.wav`;

export const waitForImages = async (element: HTMLElement) => {
  const images = Array.from(element.querySelectorAll('img'));

  await Promise.all(
    images.map(
      (image) =>
        new Promise<void>((resolve) => {
          if (image.complete) {
            resolve();
            return;
          }

          const handleComplete = () => {
            image.removeEventListener('load', handleComplete);
            image.removeEventListener('error', handleComplete);
            resolve();
          };

          image.addEventListener('load', handleComplete);
          image.addEventListener('error', handleComplete);
        }),
    ),
  );
};

export const downloadFile = (file: File) => {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');

  link.href = url;
  link.download = file.name;

  document.body.appendChild(link);
  link.click();
  link.remove();

  // 바로 revoke하면 일부 브라우저에서 다운로드가 끊길 수 있어서 살짝 늦게 처리
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
};

export const createShareUrl = (token: string) => {
  return `${window.location.origin}/free-trial/share/${token}`;
};
